"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CspireCurrencyPipe = void 0;
class CspireCurrencyPipe {
    transform(currencyValue) {
        const numberValue = currencyValue * 1;
        const isNegative = numberValue < 0;
        let returnString = '$' + Math.abs(numberValue).toFixed(2);
        if (isNegative) {
            returnString = '-' + returnString;
        }
        return returnString;
    }
}
exports.CspireCurrencyPipe = CspireCurrencyPipe;
//# sourceMappingURL=cspireCurrency.pipe.js.map